import React from "react";
import { v4 as uuidv4 } from "uuid";
import Slider from "react-slick";
import { useMediaQuery, Typography, Button, Box } from "@mui/material";
import { useTheme } from "@mui/styles";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import RightArrow from "../../img/RightArrow.svg";
import LeftArrow from "../../img/LeftArrow.svg";
import json2mq from "json2mq";
import SyllabusCard from "../SyllabusCard/SyllabusCard";
import { useLocation } from "react-router-dom";
import useTranslation from "../../hooks/useTranslation";

const useStyles = (theme, isMobile) => ({
  container: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  titleContainer: {
    marginTop: isMobile ? "110.4px" : "262.3px",
    display: { md: "flex" },
    justifyContent: { md: "center" },
    alignItems: { md: "center" },
  },
  line: {
    width: "25px",
    border: `1px solid ${theme.palette.red.main}`,
    marginRight: "8px",
    backgroundColor: theme.palette.red.main,
  },
  slider: {
    //margin: "3rem",
    width: "99%",
    height: "fit-content",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  span: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  arrow: {
    color: theme.palette.grey.main,
    fontSize: isMobile ? "0.5rem" : "2rem",
    fontWeight: "light",
  },
  downloadButton: {
    width: "245px",
    height: "52px",
    borderRadius: "100px",
    background: "linear-gradient(102deg, #f32c4d, #d00e2e)",
    color: theme.palette.white.main,
    textTransform: "none",
    fontSize: 15.5,
    fontWeight: 550,
  },
  icon: {
    p: "5px",
    height: "20px",
    width: "20px",
    borderRadius: "58px",
    color: "red",
    bgcolor: theme.palette.white.main,
    ml: "3px",
  },
  typography: {
    descriptionSubtitle: {
      fontSize: isMobile ? 14 : 16,
      fontWeight: "bold",
      letterSpacing: "2px",
      color: theme.palette.red.main,
      margin: isMobile ? "4rem 0 2rem 0" : "3rem 0 3rem 0",
    },
    section: {
      fontSize: isMobile ? "14px" : "16px",
      fontWeight: "bold",
      letterSpacing: "2px",
      color: theme.palette.red.main,
      marginTop: isMobile ? "59px" : "0",
    },
    descriptionTitle: {
      fontSize: isMobile ? 32 : 65,
      fontWeight: "lighter",
      fontFamily: theme.typography.montserrat.regular,
      color: theme.palette.blue.main,
      lineHeight: "43px",
    },
  },
});

function Arrow(props) {
  const theme = useTheme();
  const classes = useStyles(theme);
  const isMobile = useMediaQuery("(max-width:899px)");
  let className = props.type === "next" ? "nextArrow" : "prevArrow";
  className += " arrow";

  const char =
    props.type === "next" ? (
      <img
        src={RightArrow}
        alt="flecha"
        style={{
          ...classes.arrow,
          height: isMobile ? "1.5rem" : "2.3rem",
          marginRight: ".5rem",
        }}
      />
    ) : (
      <img
        alt="flecha"
        src={LeftArrow}
        style={{
          ...classes.arrow,
          height: isMobile ? "1.5rem" : "2.3rem",
          marginLeft: ".5rem",
        }}
      />
    );

  return (
    <span className={className} onClick={props.onClick} style={classes.span}>
      {char}
    </span>
  );
}

const UnitsCarrousel = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width:899px)");
  const classes = useStyles(theme, isMobile);
  const { pathname } = useLocation();
  const { title, subtitle, units, downloadButtonText } = useTranslation(
    pathname,
    "UnitsCarrousel"
  );

  const xl = useMediaQuery(
    json2mq({
      minWidth: 1641,
    })
  );

  const handleNavigation = () => {
    window.open(process.env.REACT_APP_GOOGLE_DRIVE_INTRO, "_blank").focus();
  };

  const sliderSettings = {
    infinite: true,
    slidesToShow: isMobile ? 1 : xl ? 3 : 2,
    adaptiveHeight: true,
  };

  return (
    <>
      <Box sx={classes.titleContainer}>
        {!isMobile ? <div style={classes.line}></div> : null}
        <Typography sx={classes.typography.descriptionSubtitle}>
          {title}
        </Typography>
      </Box>
      <Typography sx={classes.typography.descriptionTitle}>
        <b>{subtitle}</b>
      </Typography>
      <Slider
        {...sliderSettings}
        nextArrow={<Arrow type="next" />}
        prevArrow={<Arrow type="prev" />}
        style={classes.slider}
      >
        {units.map((unit) => (
          <SyllabusCard
            key={uuidv4()}
            units={unit.unit}
            stage={unit.stage}
            period={unit.period}
            title={unit.title}
            lessons={unit.lessons}
            color="red"
          />
        ))}
      </Slider>

      <Button
        sx={classes.downloadButton}
        endIcon={<ArrowForwardIosIcon sx={classes.icon} />}
        variant="contained"
        onClick={handleNavigation}
      >
        {downloadButtonText}
      </Button>
    </>
  );
};

export default UnitsCarrousel;
